// Central source of truth for SEO origin and Schema.org JSON-LD builders.
// The site origin comes from the VITE_SITE_URL environment variable.

export const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://usfanslink.beer';

export const faviconUrl =
  'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2277e9ffbdee9fd651886f1aeeba0d56.jpeg';

const publisher = {
  '@type': 'Organization',
  name: 'USFansLink',
  url: `${SITE_URL}/`,
  logo: {
    '@type': 'ImageObject',
    url: faviconUrl,
  },
};

export function websiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'USFansLink',
    url: `${SITE_URL}/`,
    description:
      'Independent USFans spreadsheet resource hub with guides, reviews, shipping insights, coupons and safety information in English, Polish, Spanish and French.',
    inLanguage: ['en', 'pl', 'es', 'fr'],
    publisher,
  };
}

export interface ArticleSchemaOptions {
  path: string;
  headline: string;
  description: string;
  image: string;
  dateModified: string;
}

export function articleSchema(opts: ArticleSchemaOptions) {
  const url = `${SITE_URL}${opts.path}`;
  return {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: opts.headline,
    description: opts.description,
    image: opts.image,
    url,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url,
    },
    datePublished: '2026-08-01',
    dateModified: opts.dateModified,
    author: publisher,
    publisher,
    inLanguage: 'en',
  };
}